import { v4 as uuidv4 } from 'uuid';

declare const window: Window & { dataLayer: Record<string, unknown>[] };

/**
 * Pushes an event to the dataLayer for google tag manager
 * If you want a variable to be accessible in gtm when you trigger an event,
 * pushData with the relevant info must occur before this event is triggered.
 * @param eventName the name of the event
 */
export const event = (eventName: string): void => {
  if (!window.dataLayer) {
    return;
  }
  window.dataLayer.push({
    event: eventName,
    event_id: uuidv4(), // Multiple advertisers use this parameter to deduplicate events when they get split across downstream systems
  });
};

/**
 * Pushes the provided data as dataLayer variables for google tag manager
 * @param data an object of key value pairs to push to the dataLayer
 */
export const pushData = (data: Record<string, unknown> = {}): void => {
  if (!window.dataLayer) {
    return;
  }
  window.dataLayer.push({
    ...data,
  });
};
